<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div class="endpoint-name">
    {{ options.endpoints.length === 1 ? 'Endpoint:' : 'Endpoints:' }}
    {{ endpointNames }}
</div>
<mat-dialog-content>
    <form [formGroup]="form" autocomplete="off">
        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{ 'ADM_UNAME' | translate }}</mat-label>
                <input matInput type="text" name="username" formControlName="username" autocomplete="off">
                @if (form.controls.username.hasError('usernameExists')) {
                    <mat-error>{{'policy.pba.pba-users.user-dialog.errors.username-exists' | translate}}</mat-error>
                } @else if (form.controls.username.hasError('usernameMissing')) {
                    <mat-error>{{'policy.pba.pba-users.user-dialog.errors.username-doesnt-exist' | translate}}</mat-error>
                } @else if (form.controls.username.hasError('required')) {
                    <mat-error>{{'policy.pba.pba-users.user-dialog.errors.username-required' | translate}}</mat-error>
                }
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{ 'ADM_EMAIL' | translate }}</mat-label>
                <input matInput type="text" name="email" formControlName="email">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{'APU_ROLE' | translate}}</mat-label>
                <mat-select formControlName="role">
                    <mat-option [value]="1">User</mat-option>
                    <mat-option [value]="2">User Administrator</mat-option>
                    <mat-option [value]="3">Administrator</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="password-row">
            <mat-form-field
                appearance="outline"
                [matTooltip]="'policy.pba.pba-users.user-dialog.password-requirements' | translate"
                matTooltipPosition="above">
                <mat-label>{{ 'ADO_PASS' | translate }}</mat-label>
                <input matInput type="password" name="password" formControlName="password" #passwordInput autocomplete="new-password">
                <button type="button" matSuffix mat-icon-button
                        (click)="passwordInput.type = passwordInput.type === 'text' ? 'password' : 'text'">
                    @if (passwordInput.type === 'password') {
                        <i class="mdi mdi-eye-off"></i>
                    } @else {
                        <i class="mdi mdi-eye"></i>
                    }
                </button>
                @if (form.controls.password.hasError('required')) {
                    <mat-error>{{'policy.pba.pba-users.user-dialog.errors.password-required' | translate}}</mat-error>
                } @else if (form.controls.password.hasError('pattern')) {
                    <mat-error>{{'policy.pba.pba-users.user-dialog.errors.password-invalid' | translate}}</mat-error>
                } @else if (form.controls.password.hasError('passwordValid')) {
                    <mat-error>{{'policy.pba.pba-users.user-dialog.errors.password-invalid' | translate}}</mat-error>
                }
            </mat-form-field>

            <button
                type="button"
                mat-raised-button
                [matTooltip]="'policy.pba.pba-users.user-dialog.password-requirements' | translate"
                matTooltipPosition="above"
                (click)="generatePassword()">
                Generate
            </button>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()" type="button">{{ 'CANCEL' | translate }}</button>
    <button mat-raised-button (click)="onSave()" type="button" color="primary" [disabled]="form.invalid">
        @if (options.mode === 'edit') {
            {{ 'APP_UPDATE' | translate }}
        } @else {
            {{ 'ADU_TITLE' | translate }}
        }
    </button>
</mat-dialog-actions>